const { sin, cos, sqrt, PI, pow, round, random, floor, ceil, atan2, imul, clz32, exp, E, sign } = Math;

export { sin, cos, sqrt, PI, pow, round, random, floor, ceil, atan2, imul, clz32, exp, E, sign };

export const TAU = PI * 2;

export function min(a: number, b: number) {
  return a < b ? a : b;
}

export function max(a: number, b: number) {
  return a > b ? a : b;
}

export function abs(x: number) {
  return x > 0 ? x : -x;
}

export function clamp(x: number, lo: number = 0, hi: number = 1) {
  return x > hi ? hi : x < lo ? lo : x;
}

export function lerp(a: number, b: number, t: number) {
  return a * (1 - t) + b * t;
}

export function reach(current: number, target: number, step: number) {
  return current < target ? min(current + step, target) : max(current - step, target);
}

export function smoothstep(edge0: number, edge1: number, x: number) {
  const T = clamp((x - edge0) / (edge1 - edge0));
  return T * T * (3 - 2 * T);
}

export function fract(x: number) {
  return x - (x | 0);
}

export function triangleSignArea(x0: number, y0: number, x1: number, y1: number, x2: number, y2: number) {
  return (x0 - x2) * (y1 - y2) - (x1 - x2) * (y0 - y2);
}

export function changeBits(bitset: number, mask: number, selected: boolean) {
  return selected ? bitset | mask : bitset & ~mask;
}

export function normalizeTimeRange(t: number, start: number, end: number) {
  return clamp((t - start) / (end - start));
}

export function signum(x: number) {
  return x > 0 ? 1 : x < 0 ? -1 : 0;
}

export function isPowerOfTwo(x: number) {
  return !!x && !(x & (x - 1));
}

export function nextPowerOfTwo(x: number) {
  return x <= 1 ? 1 : 1 << (32 - clz32(x - 1));
}

export function copySign(x: number, y: number) {
  return sign(x) === sign(y) ? x : -x;
}

export function fixFloat(x: number, a = 1e6): number {
  return round(x * a) / a;
}
